import React from "react";

const NavBarSettingsContainer = () => {
    return(
        <>
            <li className="nav-item order-2 order-md-1"><a href="#" className="nav-link" title="settings"><i
                className="fa fa-cog fa-fw fa-lg"></i></a></li>
            </>
    )
};
export default NavBarSettingsContainer;